export enum CHANGE_OPTIONS {
  JUST_THIS_SESSION = "justThisSession",
  ALL_FUTURE_OCCURRENCES = "allFutureOccurrences",
  FUTURE_OCCURRENCES_AFTER = "futureOccurrencesAfter",
  ALL_SESSIONS_IN_SEQUENCE = "allSessionsInSequence",
}
